import React from 'react'
import styled from 'styled-components'

interface Props {
  fluid?: boolean
  className?: string
}

const StyledContainer = styled.div<Props>`
  margin: 0 auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  max-width: ${props => (props.fluid ? '100%' : '1240px')};
`

export const Container: React.FC<Props> = ({ children, fluid, className }) => {
  return (
    <StyledContainer className={className} fluid={fluid}>
      {children}
    </StyledContainer>
  )
}
